import React from 'react';

import { useGetParams } from '../../hooks/useGetParams';

import styles from './AdvtFullSize.module.css';

import logo from '../../assets/images/logo.png';

const AdvtFullSize = React.memo(({ advtInfo }) => {
  const { sizeQR, titleFontSize } = useGetParams();

  return (
    <div className={styles.wrapper}>
      <div className={styles.logo}>
        <img src={logo} alt="" />
      </div>
      {(advtInfo.qrCode || advtInfo.label) && (
        <div className={styles.qrWrapper}>
          {advtInfo.label && (
            <div
              className={styles.title}
              style={{ fontSize: `${titleFontSize}rem` }}
            >
              {advtInfo.label}
            </div>
          )}

          {advtInfo.qrCode && (
            <div
              className={styles.qrCode}
              style={{
                width: `${sizeQR}rem`,
                height: `${sizeQR}rem`,
              }}
            >
              <img src={advtInfo.qrCode} alt="" />
            </div>
          )}
        </div>
      )}
    </div>
  );
});

export default AdvtFullSize;
